import React from 'react'
import { useTranslate } from './TranslationText';

export default function HorseResultsTable({ showData, currentHorseData = [] }) {
    const { translate } = useTranslate();
    const isHeadAndNeck = showData?.isHeadNeakType ?? false;
    const isWalkTrotType = showData?.isWalkTrotType ?? false;

    return (
        <table className='w-100 minWidth600 table table-striped table-bordered'>
            <thead>
                <tr className='bgDarkGray text-center'>
                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}></th>
                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.type', 'Type')}</th>
                    {isHeadAndNeck ?
                        <>
                            <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.head', 'Head')}</th>
                            <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.neck', 'Neck')}</th>
                            <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.headAndNeck', 'H&N')}</th>

                        </>
                        :
                        <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.headAndNeck', 'H&N')}</th>
                    }
                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.body', 'Body')}</th>
                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.legs', 'Legs')}</th>
                    {isWalkTrotType ?
                        <>
                            <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.walk', 'Walk')}</th>
                            <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.trot', 'Trot')}</th>
                            <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.move', 'Move')}</th>
                        </> :
                        <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.move', 'Move')}</th>
                    }
                    <th className='roboto-light font-weight-bold text-white fw-bold' style={{ backgroundColor: 'unset', }}>{translate('web.total', 'Total')}</th>
                </tr>
            </thead>
            <tbody>
                {currentHorseData?.scoringTable?.length > 0 ?
                    currentHorseData?.scoringTable?.map((row, index) => (
                        <tr className='text-center'>
                            <td className='bgDarkGray text-white fw-bold' style={{ background: '#757575' }}>{row?.judgeLetter}</td>
                            <td>{row?.type}</td>
                            {isHeadAndNeck ?
                                <>
                                    <td>{row?.head}</td>
                                    <td>{row?.neck}</td>
                                    <td>{row?.headNeck}</td>
                                </>
                                :
                                <td>{row?.headNeck}</td>
                            }
                            <td>{row?.body}</td>
                            <td>{row?.leg}</td>
                            {isWalkTrotType ? <>
                                <td>{row?.walk}</td>
                                <td>{row?.trot}</td>
                                <td>{row?.move}</td>
                            </> :
                                <td>{row?.move}</td>}
                            {index == 0 && <td className='bgGray' rowSpan={currentHorseData?.scoringTable?.length}>
                                <div className='d-flex justify-content-center flex-column align-items-center'>
                                    <div className='capatalize_text'>{row?.totalPoints}</div>
                                    <div className='capatalize_text'>{translate('web.points', 'Points')} </div>
                                </div>
                            </td>}
                        </tr>
                    ))
                    : <tr className='text-center'>
                        {/* <td colSpan={7} className='text-center text-danger fw-bold' >{translate('web.noResultsFound', 'No Results Found')}</td> */}
                    </tr>}
            </tbody>
        </table>
    )
}
